import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { TableCellRight } from './TableCellRight';

const Totals = ({ record }: any) => {
    if (!record) return null;

    const amount = Number(record?.amount) || 0;
    const discount = Number(record?.discount) || 0;
    const tax = Number(record?.tax) || 0;

    const finalTotal = amount - discount + tax;

    return (
        <Table sx={{ minWidth: '35em' }}>
            <TableBody>
                <TableRow>
                    <TableCell>Amount</TableCell>
                    <TableCellRight>
                        {amount.toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'INR',
                        })}
                    </TableCellRight>
                </TableRow>

                <TableRow>
                    <TableCell>Discount</TableCell>
                    <TableCellRight>
                        {discount.toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'INR',
                        })}
                    </TableCellRight>
                </TableRow>

                <TableRow>
                    <TableCell>Tax</TableCell>
                    <TableCellRight>
                        {tax.toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'INR',
                        })}
                    </TableCellRight>
                </TableRow>

                <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                        Total
                    </TableCell>
                    <TableCellRight sx={{ fontWeight: 'bold' }}>
                        {finalTotal.toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'INR',
                        })}
                    </TableCellRight>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default Totals;